export function hexColorToPixiColor(hex) {
  if (hex.indexOf('#') === -1 || hex.length !== 7) {
    throw new Error(`Color provided to hexColorToPixiColor is not a CSS hex color (${hex})`);
  }

  return Number(hex.replace('#', '0x'));
}
